import 'twin.macro';
import 'styled-components/macro';

import { LoadingImage } from 'component-lib/atoms/LoadingImage/LoadingImage';

import { SweetCard, SweetCardItem } from '../sweet-card/SweetCard';

export interface FavoritesSuggestProps {
  loading: boolean;
  items: SweetCardItem[];
}

export const FavoritesSuggest = ({ items, loading }: FavoritesSuggestProps) => {
  if (loading) {
    return <LoadingImage />;
  }

  if (!items.length) {
    return <></>;
  }

  return (
    <div>
      <h2 tw="display-3 mb-1">You also liked these stuff</h2>

      <div tw="grid grid-cols-4 gap-2">
        {items.map(sweet => (
          <SweetCard key={sweet.id} item={sweet}></SweetCard>
        ))}
      </div>
    </div>
  );
};
